import { Canvas, invalidate } from "@react-three/fiber";
import Performance from "./Performance";
import Lights from "./Lights";
import Controls from "./Controls";
import Effects from "./Effects";
import { Stage, Environment } from "@react-three/drei";
import Gate from "./Product/Gate";
import { Euler } from "three";
import { useEffect, Suspense } from "react";
import { useThree } from "@react-three/fiber";
import { useAppStore, AppStoreState } from "@/stores/appStore";

interface SceneUpdaterProps {
	configurator: AppStoreState["configurator"];
}

function SceneUpdater({ configurator }: SceneUpdaterProps) {
	const { invalidate } = useThree();

	useEffect(() => {
		invalidate(); // Forces the canvas to re-render and update shadows
	}, [configurator, invalidate]);

	return null;
}

export default function Scene() {
	const configurator = useAppStore((state) => state.configurator);

	return (
		<Canvas
			id="three-canvas"
			onPointerDown={() => invalidate()} // Fixes issue with cameraControls not being updated when rendering on demand.
			dpr={1.5}
			frameloop="always"
			shadows
			camera={{ fov: 45, position: [-2, 0.5, 1.5] }}
			style={{ width: "100%", height: "100svh" }}>
			<Performance>
				<Controls />
				<Suspense>
					<Stage
						intensity={0}
						shadows={{
							type: "accumulative",
							bias: -0.001,
							intensity: Math.PI,
							temporal: false,
						}}
						adjustCamera={false}>
						<Lights />
						<Effects />
						<Gate />
						<Environment
							files={["/hdri/venice_sunset_1k.hdr"]}
							background
							blur={0.8}
							backgroundRotation={new Euler(0, Math.PI / 4, 0)}
						/>
					</Stage>
				</Suspense>
				<SceneUpdater configurator={configurator} />
				{/* <axesHelper args={[10]} /> */}
			</Performance>
		</Canvas>
	);
}
